import { render, staticRenderFns } from "./TopicEpq.vue?vue&type=template&id=27f51cca"
import script from "./TopicEpq.vue?vue&type=script&lang=js"
export * from "./TopicEpq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports